/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */

/* eslint-disable react/no-unused-prop-types */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { hasConvertedColumns } from 'AdsUI/selectors/ColumnsSelectors';
import withQueryParams from 'AdsUI/lib/withQueryParams';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import CurrencyValue from './CurrencyValue';
import { getCurrencySymbol } from 'AdsUI/lib/Utils';

const SingleCurrencyMetric = ({
  column,
  replacementColumn,
  value: {
    amount,
    currencyCode
  },
  setQueryParam
}) => {
  const hasAccessToConvertedColumns = useSelector(hasConvertedColumns);
  const onClick = useCallback(() => {
    setQueryParam('showEditColumns', 'true');
  }, [setQueryParam]);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.multiCurrencyTooltip.useMultiCurrency",
        options: {
          column,
          replacementColumn
        }
      }), ' ', hasAccessToConvertedColumns && /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "campaigns.multiCurrencyTooltip.addToColumn_jsx",
        options: {
          onClick,
          column,
          replacementColumn
        },
        elements: {
          Link: UILink
        }
      })]
    }),
    disabled: amount !== null,
    children: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(CurrencyValue, {
        value: amount,
        currencySymbol: getCurrencySymbol(currencyCode)
      })
    })
  });
};

SingleCurrencyMetric.propTypes = {
  column: PropTypes.string.isRequired,
  replacementColumn: PropTypes.string.isRequired,
  value: PropTypes.shape({
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    currencyCode: PropTypes.string
  }).isRequired,
  addClasses: PropTypes.string
};
export default withQueryParams(SingleCurrencyMetric);